// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2X0NS","title":"Navbar_title__2OXBf"};